import { ContractTypes } from "app/models/user"
import { FilterActionResult } from "../filter/filter.actions"
import createFilterReducer, { DEFAULT_STATE, FilterableEntities } from "../filter/filter.reducer"

export type AvailabilitiesFilter = {
  [k: string]: string[] | string | undefined
  q: string | undefined
  contract_type: ContractTypes | undefined
}

const INITIAL_AVAILABILITIES_FILTER_STATE = {
  ...DEFAULT_STATE,
  filterableFields: { contract_type: [ContractTypes.PAYROLL, ContractTypes.EXTERNAL] },
  filters: { q: undefined, contract_type: undefined },
}

const availabilitiesFilterReducer = (
  state = INITIAL_AVAILABILITIES_FILTER_STATE,
  action: FilterActionResult<AvailabilitiesFilter>,
) => createFilterReducer<AvailabilitiesFilter>(FilterableEntities.Availabilities)(state, action)

export default availabilitiesFilterReducer
